import { getContentHeight } from 'components/sections/Navigation/utils';
import { useCallback, useMemo, useRef, useState } from 'react';
import useSport from 'store/sport';
import useWindowResize from 'hooks/useWindowResize';
import SectionLoader from 'components/sections/SectionLoader/SectionLoader';

const Atlas = ({ sportId }: { sportId: string }) => {
  const ref = useRef(null);
  const [sportState] = useSport();
  const [, setIsLoaded] = useState(false);

  const [height, setHeight] = useState<number>();

  const handleWindowHeight = useCallback(() => {
    setHeight(getContentHeight());
  }, []);

  useWindowResize(handleWindowHeight);

  const url = useMemo(() => {
    if (!sportState.data[sportId]) return;

    const { url, username, token } = sportState.data[sportId];

    const result = new URL(url);
    username && result.searchParams.append('user', username);
    token && result.searchParams.append('token', token);

    return result.toString();
  }, [sportState.data[sportId]]);

  if (!sportState.data[sportId]) return <SectionLoader />;

  return (
    <>
      <iframe
        ref={ref}
        src={url}
        onLoad={() => {
          setIsLoaded(true);
          setHeight(getContentHeight());
        }}
        style={{ width: '100%', border: 0, height }}
      />
    </>
  );
};

export default Atlas;
